import type { SlideDef } from "./types";
import { slides as chapter1 } from "@/slides/chapter-1";
import { slides as chapter2 } from "@/slides/chapter-2";
import { slides as chapter3 } from "@/slides/chapter-3";
import { slides as chapter4 } from "@/slides/chapter-4";
import { slides as chapter5 } from "@/slides/chapter-5";
import { slides as chapter6 } from "@/slides/chapter-6";
import { slides as chapter7 } from "@/slides/chapter-7";

/**
 * FROZEN after the foundation phase. Chapter agents never edit this file —
 * they only rewrite the contents of their own src/slides/chapter-N/ folder.
 */
export const slides: SlideDef[] = [
  ...chapter1,
  ...chapter2,
  ...chapter3,
  ...chapter4,
  ...chapter5,
  ...chapter6,
  ...chapter7,
];

if (process.env.NODE_ENV !== "production") {
  const ids = new Set<string>();
  for (const s of slides) {
    if (ids.has(s.id)) throw new Error(`Duplicate slide id: ${s.id}`);
    if (!s.id.startsWith(`c${s.chapter}-`)) {
      throw new Error(
        `Slide id "${s.id}" must start with "c${s.chapter}-" (its chapter prefix)`,
      );
    }
    ids.add(s.id);
  }
}
